import { ViewResolver } from '@Components/ViewResolver';
import RenderHeaderDesktop from './desktop/RenderHeaderDesktop';
import RenderHeaderMobile from './mobile/RenderHeaderMobile';

interface RenderHeaderProps {
  onCancel: () => void;
  handleBack?: () => void;
  headerCaption: string;
  HeaderButtons?: JSX.Element;
}

const RenderHeader: React.FC<RenderHeaderProps> = (props) => {
  return (
    <ViewResolver
      desktop={<RenderHeaderDesktop {...props} />}
      mobile={<RenderHeaderMobile {...props} />}
    />
  );
};

export default RenderHeader;
